/**
 * read me:rank组件相关数据请求接口
 * Created by pengtao on 2018/9/27
 */

import nr from 'nr'
const apiCommon = nr.loadScript('api-common')
const memory = nr.loadScript('memory')

const getListData = apiCommon.getCommonData
const urlBase = memory.urlBase
const getDateUrl = urlBase + 'list/getDate'
const getRankUrl = urlBase + 'list/'
const cloudUrl = urlBase + 'main/v1/'
const getTtRankUrl = urlBase + 'main/v1/toutiao/getTouTiaoList'
const getPgcRankUrl = urlBase + 'pgc/list/getPgcList'
const getTaoLiveTelecastUrl = urlBase + 'main/v1/tao/'
const getMoreRankListUrl = urlBase + 'weixinrank/item/search'
const isRankExsitUrl = urlBase + 'account/field/isExist'
const rankDetailsInfo = urlBase + 'weixinrank/period/searchByName'
const tikTokListUrl = urlBase + 'main/v1/douyin/ranks'

export const weixinTypes = memory.weixinTypes

// 获取相关日期信息
export function getDateInfo (success, fail) {
  return getListData(getDateUrl, {}, success, fail)
}
// 获取微信榜单信息
export function getWxRankInfo (data, success, fail) {
  return getListData(cloudUrl + data.period + '/rank', {
    rank_name_group: data.rankNameGroup,
    rank_name: data.menuType,
    start: data.startTime,
    end: data.endTime
  }, success, fail)
}

// 获取微博榜单信息   只有日、周榜单   start和end时间不一样  typeMenu不一样
export function getWbRankInfo (data, success, fail) {
  return getListData(cloudUrl + data.period + '/rank', {
    rank_name_group: '',
    rank_name: data.menuType,
    start: data.startTime,
    end: data.endTime
  }, success, fail)
}

// 获取头条号榜单信息    只有日、周榜单   start和end时间不一样  typeMenu不一样 (周三更新榜单 现在在周三之前显示上一周时段，反之显示本周时段；请求的start、end从周三到周三)
export function getTtRankInfo (data, success, fail) {
  return getListData(getTtRankUrl, {
    flag: data.period,
    sub_type: data.menuType, // 总排名
    start: data.startTime,
    end: data.endTime
  }, success, fail)
}

// 获取PGC视频榜单信息  只有周榜   typeMenu不一样
export function getPgcRankInfo (data, success, fail) {
  return getListData(getPgcRankUrl, {
    flag: 'week',
    sub_type: data.menuType,  // 总排名
    start: data.startTime,
    end: data.endTime
  }, success, fail)
}

// 获取淘直播榜单信息  周榜只传倒推的那一天的日期   月榜只传对应月份的最后一天的日期   没有menuType
export function getTaoLiveTelecast (data, success, fail) {
  return getListData(getTaoLiveTelecastUrl + data.period + '/getRankData', {
    type: data.period,
    date: data.time
  }, success, fail)
}

// 获取更多榜单概览详情榜    搜索类型  type:  999:行业,  1:区域   2:平台
export function getMoreRankList (type, success, fail) {
  return getListData(getMoreRankListUrl, {
    page: 0,
    size: 100,
    type: type
  }, success, fail)
}

// 判断对应榜单是否存在
export function judgeRankList (name, success, fail) {
  return getListData(isRankExsitUrl, {name: name}, success, fail)
}

// 根据榜单名称搜索榜单详细信息
export function getRankDetailsInfo (name, success, fail) {
  return getListData(rankDetailsInfo, {
    name: name,
    page: 0,
    size: 0
  }, success, fail)
}

// 获取抖音榜单数据
export function getTikTokList (params, success, fail) {
  return getListData(tikTokListUrl, {
    start: params.startTime,
    end: params.endTime,
    sub_type: params.subType,
    flag: params.flag
  }, success, fail)
}

// 获取选取时间对应的period值
export function getPeriod (dayArr, weekArr, currentTime) {
  if (dayArr.indexOf(currentTime) > -1) {
    return '日榜'
  } else if (weekArr.indexOf(currentTime) > -1) {
    return '周榜'
  } else {
    return '月榜'
  }
}

// 辅助函数  格式化日期
function formatTime (date) {
  return (+date) >= 10 ? date : ('0' + date)
}

function Format(date,fmt){
    var o = {
        "M+" : date.getMonth()+1,                 //月份
        "d+" : date.getDate(),                    //日
        "h+" : date.getHours(),                   //小时
        "m+" : date.getMinutes(),                 //分
        "s+" : date.getSeconds(),                 //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S"  : date.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt)){
      fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    }

    for(var k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
};

// 根据初始日期获取日榜时间数组
export function getDaySelection (dayStartTime) {
  let timeStr = dayStartTime.split(' ')[0]
  let daySelectionArr = []
  let startTimeStamp = new Date(timeStr.replace(/-/g, '/')).getTime()
  let temp, handleTemp
  let dayYear = []
  for (let i = 0; i < 7; i++) {
    temp = startTimeStamp - 86400000 * i
    // handleTemp = new Date(temp).toLocaleDateString().split('/')
    handleTemp = Format(new Date(temp),'yyyy-MM-dd').split('-')
    // daySelectionArr.push((formatTime(handleTemp[1]) + '月' + formatTime(handleTemp[2]) + '日'))
    daySelectionArr.push((handleTemp[1] + '月' + handleTemp[2] + '日'))
    dayYear.push(handleTemp[0])
  }
  return {
    daySelection: daySelectionArr,
    dayYear: dayYear
  }
}

// 根据初始日期获取周榜时间数组 (除淘直播、头条外的所有榜单) (周榜由返回的初始日期为最近一周开头先加6天组成最近一周，再倒推二周)
export function getWeekSelection (weekStartTime) {
  let timeStr = weekStartTime.split(' ')[0]  // 获取对应的时间 (确定的每周一更新周榜)
  let weekYear = []
  let startTimeStamp = new Date(timeStr.replace(/-/g, '/')).getTime()
  let weekSelectionArr = []
  let startTemp, endTemp, handleTemp
  for (let i = 0; i < 3; i++) {
    startTemp = startTimeStamp - 604800000 * i
    // endTemp = new Date(startTemp + 518400000).toLocaleDateString().split('/')
    // handleTemp = new Date(startTemp).toLocaleDateString().split('/')
    endTemp = Format(new Date(startTemp + 518400000),'yyyy-MM-dd').split('-')
    handleTemp = Format(new Date(startTemp),'yyyy-MM-dd').split('-')
    // weekSelectionArr.push((formatTime(handleTemp[1]) + '月' + formatTime(handleTemp[2]) + '日-' + formatTime(endTemp[1]) + '月' + formatTime(endTemp[2]) + '日'))
    weekSelectionArr.push(handleTemp[1] + '月' + handleTemp[2] + '日-' + endTemp[1] + '月' + endTemp[2] + '日')
    weekYear.push({
      start: handleTemp[0],
      end: endTemp[0]
    })
  }
  return {
    weekSelection: weekSelectionArr,
    weekYear: weekYear
  }
}

// 根据初始日期获取 淘直播 周榜时间数组 (淘直播周榜由返回的初始日期为最近一周周末直接倒推三周)
export function getTaoWeekSelection (weekStartTime) {
  let timeStr = weekStartTime.split(' ')[0]
  let weekYear = []
  let startTimeStamp = new Date(timeStr.replace(/-/g, '/')).getTime()
  let weekSelectionArr = []
  let startTemp, endTemp, handleTemp
  for (let i = 0; i < 3; i++) {
    startTemp = startTimeStamp - 604800000 * i
    // endTemp = new Date(startTemp - 518400000).toLocaleDateString().split('/')
    // handleTemp = new Date(startTemp).toLocaleDateString().split('/')
    endTemp = Format(new Date(startTemp + 518400000),'yyyy-MM-dd').split('-')
    handleTemp = Format(new Date(startTemp),'yyyy-MM-dd').split('-')
    // weekSelectionArr.push((formatTime(endTemp[1]) + '月' + formatTime(endTemp[2]) + '日-' + formatTime(handleTemp[1]) + '月' + formatTime(handleTemp[2]) + '日'))
    weekSelectionArr.push(endTemp[1] + '月' + endTemp[2] + '日-' + handleTemp[1] + '月' + handleTemp[2] + '日');
    weekYear.push({
      start: endTemp[0],
      end: handleTemp[0]
    })
  }
  return {
    weekSelection: weekSelectionArr,
    weekYear: weekYear
  }
}

// 根据初始日期获取 头条号 周榜时间数组 (头条号周榜每周三固定时间更新，故会根据当前时间是否过了周三得出最近一周的时间)
export function getToutiaoWeekSelection (weekStartTime) {
  let timeStr = weekStartTime.split(' ')[0]
  let weekYear = []
  let startTimeStamp = new Date(timeStr.replace(/-/g, '/')).getTime()
  let weekSelectionArr = []
  let startTemp, endTemp, handleTemp, weekStartTimeStamp
  let hasPassWednesday = Date.now() - (startTimeStamp + 172800000)   // 现在的时间减去本周三的时间
  if (hasPassWednesday > 0) {
    weekStartTimeStamp = new Date(startTimeStamp - 432000000).getTime()  // 若过了周三  则第一周为： 上周三至本周二
  } else {
    weekStartTimeStamp = new Date(startTimeStamp - 1036800000).getTime()  // 若未过本周三  则第一周为： 上上周三至上周二
  }
  for (let i = 0; i < 3; i++) {
    startTemp = weekStartTimeStamp - 604800000 * i
    // endTemp = new Date(startTemp + 518400000).toLocaleDateString().split('/')
    // handleTemp = new Date(startTemp).toLocaleDateString().split('/')
    endTemp = Format(new Date(startTemp + 518400000),'yyyy-MM-dd').split('-')
    handleTemp = Format(new Date(startTemp),'yyyy-MM-dd').split('-')
    // weekSelectionArr.push((formatTime(handleTemp[1]) + '月' + formatTime(handleTemp[2]) + '日-' + formatTime(endTemp[1]) + '月' + formatTime(endTemp[2]) + '日'))
    weekSelectionArr.push(handleTemp[1] + '月' + handleTemp[2] + '日-' + endTemp[1] + '月' + endTemp[2] + '日');
    weekYear.push({
      start: handleTemp[0],
      end: endTemp[0]
    })
  }
  return {
    weekSelection: weekSelectionArr,
    weekYear: weekYear
  }
}

// 根据初始日期获取月榜时间数组
export function getMonthSelection (monthStartTime) {
  let timeStr = monthStartTime.split(' ')[0].split('-')
  let monthSelectionArr = []
  let handleTemp
  for (let i = 0; i < 3; i++) {
    // handleTemp = new Date(timeStr[0], +timeStr[1] - i, 0).toLocaleDateString().split('/')
    handleTemp = Format(new Date(timeStr[0], +timeStr[1] - i, 0),'yyyy-MM-dd').split('-')
    monthSelectionArr.push(handleTemp[0] + '年' + handleTemp[1] + '月')
  }
  
  return monthSelectionArr
}



// WEBPACK FOOTER //
// ./src/assets/js/api/rank.js